
import {Aliquot} from './aliquot';
import { ContainerItemAware } from './containerItem-aware';

export class ReactionSet extends ContainerItemAware {

    reactionSetItems:  Aliquot[];

	/** The current reaction plate ref. */
    currentPlateRef: string;

	/** The materialType. */
    materialType: string;

    /** The premixProduct. */
    premixProduct:boolean;

    /** The sampleBarcode. */
    sampleBarcode: string;

	/** The genomics order. */
    genomicsOrderRef: string;

    /** The sample Name. */
    sampleName :string;

    state:string;
}